import React, { useState } from 'react'
import Sidebar from '../components/MainSidebar'
import Login from '../components/Login'

const PageSideRoute = () => {
  const [isLogin, setIsLogin] = useState(sessionStorage.getItem("token"))
  const handleLoginTrue = () => {
    setIsLogin(true)
  }
  return (
    <div>
      {isLogin ? <Sidebar /> : <Login onLogin={handleLoginTrue} />}
    </div>
  )
}

export default PageSideRoute